import React from 'react';
import { Application } from '../../../models';
import { EmojiEventIcon } from '../../icons';
import VolunteeringForm from './VolunteeringForm';

interface SeventhStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function SeventhStep({
  application = null,
  isReadOnly = false,
}: SeventhStepProps) {
  const volunteering =
    'data' in (application?.volunteering ?? {})
      ? {
          ...(application?.volunteering as any).data,
          resume: application?.volunteering?.resume,
        }
      : application?.volunteering;
  console.log(volunteering);
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#FFF1CA] border border-[#FFE9AE] flex">
        <EmojiEventIcon className="h-12 w-12 m-auto text-yellow" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Leadership and Volunteerism
        </h2>
      </div>
      <div className="mt-8 flex flex-col">
        <VolunteeringForm
          application={application}
          volunteer={volunteering}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
}
